import { makeContextModule } from '@cian/react-utils';

import { type IQueryStateAppContext } from '@/packages/query-state/shared/types/appContext';

export const {
  Context: { Provider: QueryStateAppContextProvider },
  useContext: useQueryStateAppContext,
} = makeContextModule<IQueryStateAppContext>({
  contextName: 'ApplicationContext',
});
